import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Campaign } from '../../../models/campaigns-models/campaign';
import { MediaPlatformAccount } from '../../../models/campaigns-models/media-platform-account';

export const campaignsAdapter: EntityAdapter<Campaign> = createEntityAdapter<Campaign>();
export const platformsAdapter: EntityAdapter<MediaPlatformAccount> = createEntityAdapter<MediaPlatformAccount>();